export enum Truncation {
	NONE = 'none',
	THOUSANDS = 'thousands',
	MILLIONS = 'millions'
}